import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, of, ReplaySubject} from 'rxjs';
import {catchError, map, tap, debounceTime} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {TranslateLoader} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PitTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  resources = [
    {prefix: '/assets/locale/', suffix: '.json'},
    {prefix: '/api/web/action-entries-', suffix: '.json'}
  ];
  private translationLoadedSubject = new ReplaySubject(1);
  translationLoaded$ = this.translationLoadedSubject.asObservable().pipe(debounceTime(0));

  public getTranslation(lang: string): Observable<any> {
    return forkJoin(
      this.resources.map(config => this.http.get(`${config.prefix}${lang}${config.suffix}?v=${environment.appVersion}`).pipe(
          map(response => response),
          tap(
            () => {},
            e => {
              this.translationLoadedSubject.error(e);
            }
          ),
          catchError(() => of({}))
        ))
    ).pipe(
      map(response => response.reduce((a, b) => Object.assign(a, b), {})),
      tap(() => {
        this.translationLoadedSubject.next(true);
      })
    );
  }
}
